
/**
  * 参数处理
  * @param {*} params  参数
  */
 export function tansParams(params) {
  let result = ''
  for (const propName of Object.keys(params)) {
    const value = params[propName];
    var part = encodeURIComponent(propName) + "=";
    if (value !== null && value !== "" && typeof (value) !== "undefined") {
      if (typeof value === 'object') {
        for (const key of Object.keys(value)) {
          if (value[key] !== null && value[key] !== "" && typeof (value[key]) !== 'undefined') {
            let params = propName + '[' + key + ']';
            var subPart = encodeURIComponent(params) + "=";
            result += subPart + encodeURIComponent(value[key]) + "&";
          }
        }
      } else {
        result += part + encodeURIComponent(value) + "&";
      }
    }
  }
  return result
}


/**
 * @description 对象的空值处理
 * @param { Object } ridObject 需要处理的对象
 */
 export function objectNullValueRid(ridObject = {}) {
  Object.keys(ridObject).forEach((keyName) => {
    
    if ([undefined, null, ""].includes(ridObject[keyName])) {
      !Array.isArray(ridObject) && delete ridObject[keyName];
    } else if (typeof ridObject[keyName] === "object") {
      objectNullValueRid(ridObject[keyName]);
    }
  });
  
  return ridObject
}

  export function getTimeStr(value){
    const dayNum = 86400;
    const hoursNum = 3600;
    const branchNum = 60;
    if (value<branchNum) {return value + "秒";}
    if (value>=branchNum && value< hoursNum) {return Math.floor(value/branchNum) + "分";}
    if (value>=hoursNum && value< dayNum) {return Math.floor(value/hoursNum) + "小时";}
    const day = Math.floor(value/dayNum);
    const hours = Math.floor(value - day*dayNum);
    const hoursjs = Math.floor(hours/hoursNum);
    if (hours>=hoursNum && hours< dayNum) {
      const branch = Math.floor(hours - hoursjs*hoursNum);
      if (branch>=branchNum && branch< hoursNum) {return day + "天" +hoursjs + "小时" + Math.floor(branch/branchNum) + "分";}
      return day + "天" +hoursjs + "小时";
    }
    return day + "天";
  
  }
  /**
 * 格式化文案，首尾固定长度显示，中间隐藏
 * @param textContent
 * @param startLength
 * @param endLength
 * @param EllipsisStyle 省略位置需要替换成的字符串，比如省略部分替换成***或者...
 * @param suffixString 以传入内容分割需要格式化的字符串，从最后开始招一个为准
 * @returns
 */
export const middleEllipsis = (
  textContent,
  startLength,
  endLength,
  ellipsisStyle,
  suffixString
) => {
  textContent = String(textContent);
  let textContentArr = [];
  let suffix = '';

  if (suffixString) {
    (textContentArr) = textContent.split(suffixString);
    suffix = suffixString + textContentArr[textContentArr.length - 1];
    textContent = textContent.replace(`${suffix}`, '');
  }

  if (startLength + endLength >= textContent.length) {
    if (suffixString) {
      return `${textContent}${suffix}`;
    }
    return textContent;
  } else {
    if (suffixString) {
      return `${textContent.slice(0, startLength)}${ellipsisStyle}${textContent.slice(-endLength,)}${suffix}`;
    }
    return `${textContent.slice(0, startLength)}${ellipsisStyle}${textContent.slice(-endLength)}`;
  }
};

export function getYearMonthDay(value){
  const Y = value.getFullYear() + '-';
  const M = (value.getMonth() + 1 < 10 ? '0' + (value.getMonth() + 1) : value.getMonth() + 1) + '-';
  const D = value.getDate() < 10 ? '0' + value.getDate() : value.getDate();
  //return Y + M + D + hh + mm + ss;
  return Y + M + D;
}
export function GetDateStr(AddDayCount) { 
  var  dd =  new  Date();
  dd.setDate(dd.getDate()+AddDayCount); //获取AddDayCount天后的日期
  var  y = dd.getFullYear(); 
  var  m = (dd.getMonth()+1)<10? "0" +(dd.getMonth()+1):(dd.getMonth()+1); //获取当前月份的日期，不足10补0
  var  d = dd.getDate()<10? "0" +dd.getDate():dd.getDate(); //获取当前几号，不足10补0
  return  y+ "-" +m+ "-" +d; 
}
export function GetMoth(date) { 
  var  dd =  '';
  if(date){
    dd = new  Date(date)
  }else{
    dd = new  Date()
  }
  var  y = dd.getFullYear(); 
  var  m = (dd.getMonth()+1)<10? "0" +(dd.getMonth()+1):(dd.getMonth()+1); //获取当前月份的日期，不足10补0
  return  y+ "-" +m; 
}
//获取 枚举相关数据
export function getEnumsList(data,name){
  let list = []
  if(name){
    data.forEach(item => {
      if(name == item.name){
        list = item.enums
      }
    });
  }
  return list
}

export function CMap(key) {
  return new Promise(function(resolve, reject) {
    window.init = function() {
      resolve(qq); //注意这里
    };
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'http://map.qq.com/api/js?v=2.exp&callback=init&key=' + key;
    script.onerror = reject;
    document.head.appendChild(script);
  });
}

export function getIsRole(val){
  let pwoer = []
  let result = false
  // 登录之后 没有同步这个 所以第一次这个地方是没有值的 
  if(sessionStorage.getItem('user')){
    pwoer = JSON.parse(sessionStorage.getItem('user')).power;
    // pwoer = typeof sessionStorage.getItem('user') == "object"?sessionStorage.getItem('user').role.power:JSON.parse(sessionStorage.getItem('user')).role.power
    result = pwoer.includes(val)
  }
  return result
}

export function getDate(date, type) {
  const value = new Date(date)
  const Y = value.getFullYear()
  const M = (value.getMonth() + 1) < 10 ? '0' + (value.getMonth() + 1) : (value.getMonth() + 1)
  const D = value.getDate() < 10 ? '0' + value.getDate() : value.getDate()
  const H = value.getHours() < 10 ? '0' + value.getHours() : value.getHours()
  const mm = value.getMinutes() < 10 ? '0' + value.getMinutes() : value.getMinutes()
  const s = value.getSeconds() < 10 ? '0' + value.getSeconds() : value.getSeconds()

  switch (type) {
    case 'Y':
      return Y
    case 'M':
      return Y + '-' + M
    case 'D':
      return Y + '-' + M + '-' + D
    case 'H':
      return Y + '-' + M + '-' + D + ' ' + H
    case 'mm':
      return Y + '-' + M + '-' + D + ' ' + H + ':' + mm
    default:
      return Y + '-' + M + '-' + D + ' ' + H + ':' + mm + ':' + s
  }
}